import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import FilterArticle from 'hooks/FilterArticle';
import { Button } from '@material-ui/core';

//reemplazando valores de iniciales en estado

export default function ModalQuota(props) {
  const quota = props.model;

  const [dataChild, setDataChild] = useState({});

  return (
    <Modal
      title="Cuota"
      model={quota}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/quota"
      dataForce={dataChild}
    >
      {quota?.id ? undefined : (
        <FilterArticle
          fullWidth={true}
          getFilter={setDataChild}
          period
          mark
          seller
          zone
          bureau
          reqField={['provider', 'period', 'mark', 'seller', 'zone', 'bureau']}
        />
      )}

      <TextField
        label="Cuota"
        type="number"
        name="quota"
        margin="normal"
        fullWidth
        defaultValue={!!quota ? quota.quota : ''}
        required
        inputProps={{
          min: 0.01,
          step: 0.01
        }}
      />
    </Modal>
  );
}
